import { type PartialPropsOf, type PropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';
import { TagsPropsBuilder } from '../tags.props-builder';

export const tagsV2Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate tags element to v2',
  run: (props: PartialPropsOf<'tags'>): void => {
    /**
     * This migration allows setting border and background for read-only a tags element.
     * Task BL-7924
     */

    props.version ??= 1;
    if (props.version < 2 && props.content?.options?.readonly) {
      const pb = new TagsPropsBuilder(props);
      const patched = pb?.setReadonly(true).build() as PropsOf<'tags'> | undefined;
      if (patched) {
        patched.version = 2;
        Object.assign(props, patched);
      }
    }
  },
};
